<template>
    <el-dialog title="关联工单" :visible.sync="visible" @close="close">
        <el-row class="bottom20">
            <el-table ref="workorderRelationTableRef" :data="tableData" @selection-change="handleSelectionChange">
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column prop="roomid" label="数据中心">
                    <template slot="header" slot-scope="scope">
                        数据中心<br>
                        <SysroomSelectNew v-model="searchParams.roomid" @fetchAllSysrooms="fetchAllSysrooms"
                                          clearable filterable size="mini"></SysroomSelectNew>
                    </template>
                    <template slot-scope="scope">
                        {{formatRoom(scope.row.roomid)}}
                    </template>
                </el-table-column>
                <el-table-column prop="workorder" label="编号">
                    <template slot="header" slot-scope="scope">
                        编号<br>
                        <el-input size="mini" class="width70"
                                  v-model="searchParams.workorder"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="名称">
                    <template slot="header" slot-scope="scope">
                        名称<br>
                        <el-input size="mini" class="width70"
                                  v-model="searchParams.description"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="enterdate" label="计划开始时间">
                    <template slot="header" slot-scope="scope">
                        计划开始时间<br><br><br>
                    </template>
                </el-table-column>
                <el-table-column prop="schedstart" label="实际开始时间">
                    <template slot="header" slot-scope="scope">
                        实际开始时间<br><br><br>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination align="right" @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="currentPage"
                           :page-sizes="pageSizes" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-row>

        <br>

        <el-row style="text-align: right">
            <el-button center="true" type="primary" @click="btnRelationHandler">确定</el-button>
            <el-button center @click="close">关闭</el-button>
        </el-row>
    </el-dialog>
</template>

<script>

    import SysroomSelectNew from '@/components/sysroomNew'
    import WorkOrderServer from "@/api/workorder";
    import RelationServer from "@/api/relation/relation";

    export default {
        name: "WorkorderRelationDialog",

        components: {
            SysroomSelectNew,

        },

        props: {
            visible: {
                type: Boolean,
            },
            searchParams: {
                type: Object,
            },
            masterInfo: {
                type: Object,
            },
        },

        data() {
            return {
                tableData: [],

                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 25, 50, 100],
                total: 0,

                rooms: [],

                relationArray: [],
            }
        },

        methods: {
            close() {
                this.$emit('update:visible', false);
            },

            fetchAllSysrooms(rooms) {
                this.rooms = rooms;
            },

            formatRoom(dcnum) {
                let roomDesc = '';
                this.rooms.forEach(e => {
                    if (dcnum == e.id) {
                        roomDesc = e.name;
                    }
                });
                return roomDesc;
            },

            handleSizeChange(val) {
                this.pageSize = val;
                this.queryTable();
            },

            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryTable();
            },

            queryTable() {
                let params = {
                    'current': this.currentPage,
                    'size': this.pageSize,
                    'search': this.searchParams,
                };
                WorkOrderServer.workOrder.page(params, {'loading': true}).then(res => {
                    if (res.data.code == 200) {
                        this.tableData = res.data.result.records;
                        this.total = res.data.result.total;
                    }
                })
            },

            handleSelectionChange(arr) {
                this.relationArray = [];
                for (let i = 0; i < arr.length; i++) {
                    this.relationArray.push({
                        'clazz': this.masterInfo.clazz,
                        'enterby': this.masterInfo.enterby,
                        'enterdate': this.masterInfo.enterdate,
                        'orgid': this.masterInfo.orgid,
                        'siteid': this.masterInfo.siteid,
                        'recordkey': this.masterInfo.recordkey,
                        'relatedrecclass': this.masterInfo.relatedrecclass,
                        'relatedreckey': arr[i].workorder,
                        'relatedrecorgid': arr[i]['orgid'],
                        'relatedrecsiteid': arr[i]['siteid'],
                        'relatetype': this.masterInfo.relatetype,
                        'validation': this.masterInfo.validation,
                    });
                    this.relationArray.push({
                        'clazz': this.masterInfo.relatedrecclass,
                        'enterby': this.masterInfo.enterby,
                        'enterdate': this.masterInfo.enterdate,
                        'orgid': arr[i]['orgid'],
                        'siteid': arr[i]['siteid'],
                        'recordkey': arr[i].workorder,
                        'relatedrecclass': this.masterInfo.clazz,
                        'relatedreckey': this.masterInfo.recordkey,
                        'relatedrecorgid': this.masterInfo.orgid,
                        'relatedrecsiteid': this.masterInfo.siteid,
                        'relatetype': this.masterInfo.relatetype,
                        'validation': this.masterInfo.validation,
                    });
                }
            },

            btnRelationHandler() {
                RelationServer.batchRelation(this.relationArray).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('关联成功');
                        this.$emit('afterRelation');
                        this.close();
                    } else {
                        this.$message.error(res.data.message);
                    }
                });
            },
        },

        watch: {
            searchParams: {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.currentPage = 1;
                    this.total = 0;
                    this.tableData = [];

                    this.queryTable();
                }
            }
        },
    }
</script>

<style scoped>

</style>